import { cloudRevenuePriceTypes } from "../../prices/constants/cloudPriceTypes";
import { cloudPriceTypes } from "../../prices/constants/priceTypes";

import { CloudStartFeeMeta } from "../types/CloudStartFeeMeta";
import { costMetaByPriceType } from "../types/CostMeta";

export function isCloudRevenue(cost) {
	return cloudPriceTypes.includes(cost?.price?.type);
}

export function splitCloudRevenues(costs = []) {
	return {
		productionCosts: costs.filter((cost) => !isCloudRevenue(cost)),
		// A quarter's revenues read month by month, per type.
		cloudRevenues: costs
			.filter(isCloudRevenue)
			.sort(
				(a, b) =>
					a.price.type.localeCompare(b.price.type) ||
					(a.meta?.period || "").localeCompare(b.meta?.period || ""),
			),
	};
}

export function getCloudRevenueSubject(cost) {
	const isStartFee = costMetaByPriceType[cost.price?.type] === CloudStartFeeMeta;

	if (isStartFee) {
		return cost.meta?.article?.name || "";
	}

	return cost.meta?.period || "";
}

export function getCloudRevenueUnitPrice(cost) {
	return Object.values(cloudRevenuePriceTypes).includes(cost.price?.type)
		? { ...cost.price, price: cost.value, unit: "month" }
		: cost.price;
}
